import { FutureValuesSettings } from './future-values-settings.model';
import { AdjustmentUi } from '../../report/adjustments/models/adjustment-ui.model';
import { SpecificationUi } from '../../report/adjustments/models/specification-ui.model';

export class ValuationSettings {
    addUsedValues: boolean;
    addFutureValues: boolean;
    addTermSettings: boolean;
    addMileageSettings: boolean;
    futureValuationSettings: FutureValuesSettings;
    manufacturerAdjustments: Array<AdjustmentUi>;
    sectorAdjustments: Array<AdjustmentUi>;
    specificationAdjustments: Array<SpecificationUi>;
}



// WEBPACK FOOTER //
// ./src/app/report/models/valuation-settings.model.ts